import { Component } from "@angular/core";
import {
  SedsModalAbstractComponent,
  SedsSizeOptions,
} from "experian-design-system";

@Component({
    selector: "pl-custom-user-modal",
    templateUrl: "./custom-user-modal.component.html",
    styleUrls: ["./custom-user-modal.component.scss", "../../../../../styles/theme/modal.scss"],
    standalone: false
})
export class CustomUserModalComponent extends SedsModalAbstractComponent {

  smallButton = SedsSizeOptions.SMALL;
  helpUrl = "https://ajuda.serasaexperian.com.br/hc/pt-br/requests/new?criacaodelogon";
  
  constructor() {
    super();
  }


  openHelpUrl() {
    window.open(this.helpUrl, "_blank");
    this.close();
  }
}
